
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Briefcase, Home, Calendar, User, FileText } from 'lucide-react';

const industries = [
  {
    name: "CPA Firms",
    description: "Secure document management, regulatory compliance, and reliable systems during tax seasons.",
    icon: FileText
  },
  {
    name: "Real Estate Agencies",
    description: "Mobile solutions, secure remote access, and reliable communication tools.",
    icon: Home
  },
  {
    name: "Property Managers",
    description: "Secure guest Wi-Fi, tenant portals, and integrated building management systems.",
    icon: Calendar
  },
  {
    name: "Healthcare Offices",
    description: "HIPAA compliance, secure patient data, and reliable practice management solutions.",
    icon: User
  },
  {
    name: "Small Businesses",
    description: "Cost-effective IT solutions, cybersecurity, and reliable business continuity planning.",
    icon: Briefcase
  }
];

const ClientIndustries: React.FC = () => {
  return (
    <section id="industries" className="bg-itmgmt-light-gray section-padding">
      <div className="container-wide">
        <div className="text-center mb-12">
          <h2 className="heading-lg text-itmgmt-dark-blue mb-4">Industries We Serve</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We understand the unique technological challenges faced by different industries. 
            Our solutions are tailored to meet the specific needs of:
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((industry, index) => (
            <Card key={index} className="bg-white hover:shadow-md transition-shadow">
              <CardContent className="pt-6">
                <div className="flex items-start mb-4">
                  <div className="bg-itmgmt-medium-blue bg-opacity-10 p-3 rounded-lg mr-4">
                    <industry.icon className="text-itmgmt-medium-blue" size={24} />
                  </div>
                  <div>
                    <h3 className="font-bold text-itmgmt-dark-blue text-lg mb-1">{industry.name}</h3>
                    <p className="text-gray-600">{industry.description}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientIndustries;
